<template>  
  <apexchart type="bar" :height="chartHeight" width="100%" :options="chartOptions" :series="series"/>  
</template>

<script>
export default {
  name: 'HeadcountMyersBriggsChart',
  props: {
    chartData: {
      type: Array,
      default: () => []
    },
    chartHeight: {
      type: [Number, String],
      default: 400
    },    
    companyPrimaryColor: {
      type: String,
      default: '#006859'
    }
  },
  computed: {
    processedData() {
      if (!Array.isArray(this.chartData)) return [];
      return this.chartData.sort((a, b) => a.sort_order - b.sort_order);      
    },
    series() {
      return [{
        name: 'Number of Employees',
        data: this.processedData.map(item => item.count)
      }]
    },
    chartOptions() {
      return {
        chart: {
          type: 'bar',
          toolbar: { show: false },
          fontFamily: 'Manrope, Arial, sans-serif'
        },     
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '70%'
          }
        },
        dataLabels: {
          enabled: true,
          // formatter: (val) => val > 0 ? val : ''
        },
        xaxis: {
          categories: this.processedData.map(item => item.mbti_type),
          labels: {
            style: {
              fontSize: '12px'
            },
            rotate: -45
          },
          title: {
            text: 'MBTI Type',
            offsetY: 80
          }
        },
        yaxis: {
          title: {
            text: 'Number of Employees'
          },
          labels: {
            formatter: (val) => Math.round(val) === val ? val : ''
          }
        },
        tooltip: {
          y: {
            formatter: (val) => `${val} employee(s)`
          }
        },
        colors: [this.companyPrimaryColor],
        grid: {
          borderColor: '#f1f1f1'
        }
      }
    }
  }
}
</script>